





















import { Component, Prop, Vue } from "@/shared/vuepack";
import Pill from "@/shared/components/ui/Pill.vue";
import { HsabExpenseDisplayStatus, HsabExpenseDisplayStatusMap } from "@/shared/types";
import { v4 as uuid } from "uuid";

@Component({
  components: {
    Pill
  }
})
export default class HsabExpenseReimbursementStatusPill extends Vue {

  @Prop({ required: true })
  status: HsabExpenseDisplayStatus;

  showTooltip = false;

  get showStatusPill () {
    return this.status !== HsabExpenseDisplayStatus.None;
  }

  get pillType () {
    switch (this.status) {
      case HsabExpenseDisplayStatus.Paid:
      case HsabExpenseDisplayStatus.MarkedAsPaid:
      case HsabExpenseDisplayStatus.PartiallyPaid:
        return "green-bg";
      case HsabExpenseDisplayStatus.ReceiptNeeded:
      case HsabExpenseDisplayStatus.NewReceiptNeeded:
      case HsabExpenseDisplayStatus.ReceiptOverdue:
      case HsabExpenseDisplayStatus.Error:
        return "red-bg";
      case HsabExpenseDisplayStatus.Active:
        return "blue-bg";
    }
    return "grey-bg";
  }

  get displayText () {
    return HsabExpenseDisplayStatusMap[this.status];
  }

  get displayHelpText (): { text: string; id: string } {

    switch (this.status) {
      case HsabExpenseDisplayStatus.Paid:
        return {
          text: "The expense was paid. There's no action you need to take.",
          id: "tooltip-paid" + uuid(),
        };
      case HsabExpenseDisplayStatus.PartiallyPaid:
        return {
          text: "The expense was partially paid. There's no action you need to take.",
          id: "tooltip-partiallyPaid" + uuid(),
        };
      case HsabExpenseDisplayStatus.ReceiptNeeded:
        return {
          text: "Expense submitted but a receipt is required for payment. Please upload the appropriate receipt for this expense.",
          id: "tooltip-receiptNeeded" + uuid(),
        };
      case HsabExpenseDisplayStatus.Locked:
        return {
          text: "This expense status is updating and no action can be taken at this time.",
          id: "tooltip-locked" + uuid(),
        };
      case HsabExpenseDisplayStatus.Hold:
        return {
          text: "This expense has a hold and no action can be taken at this time.",
          id: "tooltip-hold" + uuid(),
        };
      case HsabExpenseDisplayStatus.Pending:
        return {
          text: "This expense was submitted and is pending. There's no action you need to take.",
          id: "tooltip-pending" + uuid(),
        };
      case HsabExpenseDisplayStatus.Repaid:
        return {
          text: "This initially denied expense was repaid and is no longer due. There's no action you need to take.",
          id: "tooltip-repaid" + uuid(),
        };
      case HsabExpenseDisplayStatus.RepaymentDue:
        return {
          text: "This expense was paid, but later denied. You are required to repay the denied amount.",
          id: "tooltip-repaymentDue" + uuid(),
        };
      case HsabExpenseDisplayStatus.Expired:
        return {
          text: "This expense wasn't submitted before the final filing date. There's no action you can take at this time.",
          id: "tooltip-expired" + uuid(),
        };
      case HsabExpenseDisplayStatus.ReceiptOverdue:
        return {
          text: "Expense submitted but a receipt is required for payment. Please upload the appropriate receipt for this expense.",
          id: "tooltip-receiptOverdue" + uuid(),
        };
      case HsabExpenseDisplayStatus.NewReceiptNeeded:
        return {
          text: "Expense submitted but a receipt is required for payment. Please upload the appropriate receipt for this expense.",
          id: "tooltip-newReceiptNeeded" + uuid(),
        };
      case HsabExpenseDisplayStatus.Denied:
        return {
          text: "This expense doesn't qualify as an eligible expense.",
          id: "tooltip-denied" + uuid(),
        };
      case HsabExpenseDisplayStatus.Submitted:
        return {
          text: "This expense is pending. There's no action for you to take at this time.",
          id: "tooltip-submitted" + uuid(),
        };
      case HsabExpenseDisplayStatus.Resubmitted:
        return {
          text: "This resubmitted expense is pending. There's no action for you to take at this time.",
          id: "tooltip-resubmitted" + uuid(),
        };
      case HsabExpenseDisplayStatus.Applied:
        return {
          text: "This claim was submitted but isn't eligible for payment until you meet the deductible.",
          id: "tooltip-applied" + uuid(),
        };
      case HsabExpenseDisplayStatus.PendingReceipt:
        return {
          text: "This expense was submitted but requires the appropriate receipt.",
          id: "tooltip-pendingReceipt" + uuid(),
        };
      case HsabExpenseDisplayStatus.PendingReimbursement:
        return {
          text: "This expense was approved and is pending payment. There's no action for you to take.",
          id: "tooltip-pendingReimbursement" + uuid(),
        };
      case HsabExpenseDisplayStatus.ScheduledReimbursement:
        return {
          text: "This expense was approved and payment is scheduled but not yet posted. There's no action for you to take.",
          id: "tooltip-scheduledReimbursement" + uuid(),
        };
      case HsabExpenseDisplayStatus.Unsubmitted:
        return {
          text: "This expense/claim wasn't submitted for reimbursement.",
          id: "tooltip-unsubmitted" + uuid(),
        };
      case HsabExpenseDisplayStatus.MarkedAsPaid:
        return {
          text: "This expense was paid.",
          id: "tooltip-markedAsPaid" + uuid(),
        };
      case HsabExpenseDisplayStatus.Available:
        return {
          text: "This claim is not linked to an expense.",
          id: "tooltip-available" + uuid(),
        };
      case HsabExpenseDisplayStatus.Active:
        return {
          text: "This recurring expense is active and will be submitted per the schedule.",
          id: "tooltip-available" + uuid(),
        };
      case HsabExpenseDisplayStatus.Inactive:
        return {
          text: "This recurring expense is not active.",
          id: "tooltip-available" + uuid(),
        };
      case HsabExpenseDisplayStatus.Error:
        return {
          text: "This recurring expense failed to submit and is now deactivated.",
          id: "tooltip-paid" + uuid(),
        };
      default:
        return {
          text: "Claim status",
          id: "tooltip-default" + uuid(),
        };
    }
  }

  toggleTooltip () {
    this.showTooltip = !this.showTooltip; // Toggle tooltip visibility on click
  }

}
